import { Box } from '@mui/material';

const AppLayout = ({ appHeader, appContent, appFooter }) => {
  return (
    <>
      <Box component={'div'} id="app-header">
        {appHeader ? appHeader : 'no app header found.'}
      </Box>
      <Box component={'div'} id="app-content" sx={{ minHeight: '100vh' }}>
        {appContent ? appContent : 'no app content found.'}
      </Box>
      <Box component={'div'} id="app-footer">
        {appFooter ? appFooter : 'no app footer found.'}
      </Box>
    </>
  );
};

export default AppLayout;
